const videoModal = () => {
  const videoThumbnail = document.querySelector<HTMLVideoElement>('.js-video-trigger');
  const modal = document.querySelector<HTMLElement>('.js-video-modal');
  const modalContent = document.querySelector<HTMLElement>('.js-video-content');
  const modalVideo = document.querySelector<HTMLVideoElement>('.js-video');

  if (videoThumbnail) {
    videoThumbnail.addEventListener('click', () => {
      modal?.classList.add('active');
      document.body.classList.add('modal-open');
      modalVideo?.play();
    });

    modal?.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;

      if (!modalContent?.contains(target)) {
        modal.classList.remove('active');
        if (modalVideo) {
          modalVideo.pause();
          modalVideo.currentTime = 0;
        }
        document.body.classList.remove('modal-open');
      }
    });
  }
};

export default videoModal;
